<template>
  <div>
    <div class="report grid grid-cols-12 gap-8">
      <div class="col-span-7">
        <h2 class="text-xl mb-4">Jenis Cetak</h2>
        <!-- <pre>{{ valueJenisCetak }}</pre> -->
        <ul>
          <li v-for="(jenis, idx) in optionsJenisCetak" class="mb-3">
            <input
              class="hidden radio_jenis"
              :id="`radio_${jenis.id}`"
              type="radio"
              name="radio_jenis"
              :checked="idx === 0"
              @change="handleSelectedReport($event)"
              :value="jenis.id"
            />
            <label
              class="flex flex-col py-3 px-4 border rounded-md cursor-pointer"
              :for="`radio_${jenis.id}`"
            >
              <span class="text-sm font-semibold">{{ jenis.header }}</span>
              <span class="text-lg font- mt-2">{{ jenis.judul }}</span>
              <!-- :color="[{ primary: true }]" -->
              <CBadge
                class="text-xs w-14 text-white mt-2"
                :class="[
                  {
                    'bg-indigo-600': jenis.filetype == 'pdf',
                    'bg-yellow-600': jenis.filetype == 'excel',
                  },
                ]"
                >{{ jenis.filetype }}</CBadge
              >
            </label>
          </li>
        </ul>
      </div>
      <div class="col-span-5">
        <h2 class="text-xl mb-4 px-2">Opsi Cetak</h2>
        <CRow class="border rounded-md mx-2 px-2 py-3">
          <CCol lg="12" class="mb-2">
            <h3 class="text-base">Priode LHA</h3>
          </CCol>
          <CCol lg="6">
            <label class="typo__label block">Tanggal Mulai</label>
            <v-date-picker
              v-model="opsiCetak.dateMulai"
              mode="single"
              :input-debounce="500"
              is-required
              :masks="{ input: ['DD/MM/YYYY'] }"
              :disabled-dates="
                valueJenisCetak.isNotUsePeriod && [
                  {
                    start: null,
                    end: null,
                  },
                ]
              "
            />
            <!-- :masks="{ input: ['D MMM YYYY'], data: ['YYYY-MM-DD'] }" -->
          </CCol>
          <CCol lg="6">
            <label class="typo__label block">Tanggal Selesai</label>
            <v-date-picker
              v-model="opsiCetak.dateSelesai"
              mode="single"
              :input-debounce="500"
              is-required
              :masks="{ input: ['DD/MM/YYYY'] }"
              :disabled-dates="
                valueJenisCetak.isNotUsePeriod && [
                  {
                    start: null,
                    end: null,
                  },
                ]
              "
            />
            <!-- :masks="{ input: ['D MMM YYYY'], data: ['YYYY-MM-DD'] }" -->
          </CCol>
          <CCol lg="12" class="mt-2" v-if="valueJenisCetak.isNotUsePeriod">
            <p class="italic text-red-400">
              Jenis cetak ini tidak memiliki periode tanggal mulai dan selesai
            </p>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol lg="12" class="mx-2">
            <!-- <CButton key="primary-lg" color="info" variant="ghost" class="px-4">
              Reset
            </CButton> -->
            <!-- <CButton
              key="primary-lg"
              color="danger"
              variant="outline"
              class="px-4 mx-3"
            >
              Batal
            </CButton> -->
            <CButton
              key="primary-lg"
              color="success"
              class="px-4"
              @click="handleClickCetak"
            >
              Cetak
            </CButton>
          </CCol>
        </CRow>
      </div>
    </div>
    <Loading :active.sync="loading" :is-full-page="true" />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { DatePicker } from 'v-calendar';
import mixinReportHasilAuditPerTemuan from './reportHasilAuditPerTemuan';
import mixinReportHasilAuditPerRekomendasi from './reportHasilAuditPerRekomendasi';
import reportRekapitulasiPerLha from './reportRekapitulasiPerLha';
import reportRekapitulasiPerInstansi from './reportRekapitulasiPerInstansi';
import mixinReportTptlExcel from './reportTptlExcel';
import mixinReportTemuanrekomendasiperlhaToExcel from './reportTemuanrekomendasiperlhaExcel';
import mixinRincianTemuanTl from './reportRincianTemuanTl';

import Loading from 'vue-loading-overlay';
export default {
  name: 'ReportIndex',
  components: {
    Multiselect,
    'v-date-picker': DatePicker,
    Loading,
  },
  filters: {},
  mixins: [
    mixinReportHasilAuditPerTemuan,
    mixinReportHasilAuditPerRekomendasi,
    reportRekapitulasiPerLha,
    reportRekapitulasiPerInstansi,
    mixinReportTptlExcel,
    mixinReportTemuanrekomendasiperlhaToExcel,
    mixinRincianTemuanTl,
  ],
  props: {},
  data() {
    return {
      optionsJenisCetak: [
        // {
        //   id: 7,
        //   header: 'Laporan Hasil Audit',
        //   judul: 'Rincian Temuan dan Tindak Lanjut',
        //   endpoint: '/api/reportperlhadetail',
        //   filetype: 'pdf',
        // },
        {
          id: 1,
          header: 'Laporan Hasil Audit',
          judul: 'Rekap berdasarkan/grouping by LHA',
          // judul: "Rekap LHA berdasarkan/grouping by (Instansi)",
          endpoint: '/api/rekapitulasiperlha',
          filetype: 'pdf',
        },
        {
          id: 2,
          header: 'Laporan Hasil Audit',
          judul: 'Rekap berdasarkan/grouping by Instansi',
          // judul: "Rekap Kode Temuan berdasarkan/grouping by (Instansi)",
          endpoint: '/api/rekapitulasiperinstansi',
          filetype: 'pdf',
        },
        {
          id: 3,
          header: 'Laporan Hasil Audit',
          judul: 'Rekap berdasarkan/grouping by Kode Group Temuan',
          endpoint: '/api/reporthasilauditpertemuan',
          filetype: 'pdf',
        },
        {
          id: 4,
          header: 'Laporan Hasil Audit',
          // judul: "Report Berdasarkan Rekomendasi",
          judul: 'Rekap berdasarkan/grouping by Kode Rekomendasi',
          endpoint: '/api/reporthasilauditperrekomendasi',
          filetype: 'pdf',
        },
        {
          id: 5,
          header: 'Laporan Hasil Audit',
          judul: 'Rekap Excel TPTL Per LHA',
          endpoint: '/api/tptlperlha',
          filetype: 'excel',
        },
        {
          id: 6,
          isNotUsePeriod: true,
          header: 'Laporan Hasil Audit',
          judul: 'Rekap Excel Temuan Rekomendasi Per LHA',
          endpoint: '/api/temuanrekomendasiperlha',
          filetype: 'excel',
        },
      ],
      valueJenisCetak: '',
      formFilter: {
        nomorLha: '',
        tglLha: '',
        tahunPkpt: 2022,
        unitPengawasan: '',
        inspektorat: '',
        groupPemeriksaan: '',
        jenisPemeriksaan: '',
        sumberDataTpk: '',
        akuntabilitas: '',
        statusLha: '',
      },
      opsiCetak: {
        dateMulai: new Date('01/01/2020'), // new Date(new Date().getFullYear(), 0, 1),
        dateSelesai: new Date(),
        judulLaporan: '',
        header1: '',
        header2: '',
        header3: '',
      },
      loading: false,
    };
  },
  async mounted() {
    this.$store.commit('ui/setTitleHeader', `${'Report'}`);
    this.valueJenisCetak = this.optionsJenisCetak[0];
  },
  emits: [
    'clicked-row',
    'open-create-modal',
    'open-edit-modal',
    'open-delete-modal',
    'on-select-lha',
    'on-select-temuan',
    'on-select-rekomendasi',
    'on-load-tl',
  ],
  methods: {
    viewSelectSearch({ id, jenis }) {
      return `${id} - ${jenis}`;
    },
    handleSelectedReport(e) {
      this.valueJenisCetak = this.optionsJenisCetak.filter(
        (item) => item.id == e.target.value
      )[0];
    },
    async handleClickCetak() {
      this.loading = true;
      switch (this.valueJenisCetak.id) {
        case 1:
          await this.rekapitulasiPerLha(this.valueJenisCetak, this.opsiCetak);
          break;
        case 2:
          await this.rekapitulasiPerInstansi(
            this.valueJenisCetak,
            this.opsiCetak
          );
          break;
        case 3:
          await this.reportHasilAuditPerTemuan(
            this.valueJenisCetak,
            this.opsiCetak
          );
          break;
        case 4:
          await this.reportHasilAuditPerRekomendasi(
            this.valueJenisCetak,
            this.opsiCetak
          );
          break;
        case 5:
          await this.exportTptlToExcel(this.valueJenisCetak, this.opsiCetak);
          break;
        case 6:
          await this.exportTemuanrekomendasiperlhaToExcel(
            this.valueJenisCetak,
            this.opsiCetak
          );
          break;
        case 7:
          await this.rincianTemuanTl(this.valueJenisCetak, this.opsiCetak);
          break;
      }
      this.loading = false;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.report .multiselect__option {
  font-size: 12px;
  font-weight: 600;
}
input:checked + label {
  background-color: #14b8a6;
  color: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
</style>
